class Review {
    constructor() {

        const reviwProductId = document.querySelector('.reviwProductId');

        if (reviwProductId) {
            this.productId = reviwProductId.dataset.id;
            this.xhr = new XMLHttpRequest();
            this.event();
        }

    }

    event = () => {
        this.load(this.productId);

        const btnAddReview = document.querySelector('#button-review');

        if (btnAddReview) {
            btnAddReview.addEventListener('click', e => {
                this.write();
            });
        }
    }

    load = (id, page = '') => {
        
        if(page)
            page = '&page=' + page

        this.xhr.open('POST', 'index.php?route=product/product/review&product_id=' + id + page);
        this.xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        this.xhr.send();

        this.xhr.onload = () => {
            if (this.xhr.readyState !== 4) return;

            if (this.xhr.status == 200) {
                const review = document.querySelector('#review');

                review.innerHTML = this.xhr.response;
                // review.insertAdjacentHTML('afterbegin', this.xhr.response);
                
                const links = document.querySelectorAll('.review-pagination .pagination a');
                if (links) {
                    links.forEach(el => {
                        el.addEventListener('click', (e) => {
                            e.preventDefault();
                            const url = new URL(e.target.getAttribute('href'));
                            this.load(id,  url.searchParams.get('page'));
                        });
                    })
                }
            }
        }
    }

    write = () => {
        this.xhr.open('POST', 'index.php?route=product/product/write&product_id=' + this.productId);

        const form = document.querySelector('.form-review');
        this.xhr.send(new FormData(form));

        this.xhr.onload = () => {
            if (this.xhr.readyState !== 4) return;

            if (this.xhr.status == 200) {
                const json = JSON.parse(this.xhr.response);

                if (json["error"]) this.msgError(json["error"]);

                if (json["success"]) {
                    this.msg(json);
                    form.reset();
                }
            }
        }
    }

    pagination = (data) => {

    }

    msg = (m) => {
        document.querySelector('.msg-container').insertAdjacentHTML('beforeend',
            `<div class="msg">
            <div class="msg-body"><i class="bi bi-emoji-smile"></i> ${m["success"]}</div>
            </div>`
        );

        document.querySelectorAll('.msg').forEach(el => {
            setTimeout(function () { el.remove(); }, 3000);
        });
    }

    msgError = (m) => {
        document.querySelector('.msg-container').insertAdjacentHTML('beforeend',
            `<div class="msg msg__error">
            <div class="msg-body"><i class="bi bi-emoji-frown"></i> ${m}</div>
            </div>`
        );

        document.querySelectorAll('.msg').forEach(el => {
            setTimeout(function () { el.remove(); }, 3000);
        });
    }
}